import React from 'react';
import { GiftIcon } from 'lucide-react';
import { formatPrice } from '../data/config';
import { CheckItem } from './CheckItem';
type Group = {
  label: string;
  text: string;
};
type BonusCardProps = {
  number: string;
  title: string;
  collection?: string;
  subtitle: string;
  price: number;
  intro: string[];
  list?: string[];
  groups?: Group[];
  outro?: string[];
  finalLine: string;
  meta?: string;
  showReferencePrice: boolean;
};
export function BonusCard({
  number,
  title,
  collection,
  subtitle,
  price,
  intro,
  list,
  groups,
  outro,
  finalLine,
  meta,
  showReferencePrice
}: BonusCardProps) {
  return <article className="rounded-md border-l-[5px] border-gold bg-white px-3.5 py-3 text-left md:px-4 md:py-3.5" data-id="element-17" data-mp="29dus36rsxfr5">
      <h3 className="flex items-start gap-2 font-heading text-[14px] font-extrabold uppercase leading-tight text-navy md:text-[15px]" data-id="element-18" data-mp="2e7z1dwojhzve">
        <GiftIcon className="mt-px h-4 w-4 shrink-0 text-goldDark" strokeWidth={2.5} aria-hidden data-id="element-19" data-mp="1lp1rgx08ijq7" />
        <span data-id="element-20" data-mp="1x2ms3b8ndy91">
          Bonus {number} — {title}
        </span>
      </h3>
      {collection && <p className="mt-1 pl-6 font-heading text-[12px] font-extrabold uppercase leading-tight text-navy/80 md:text-[13px]" data-id="element-21" data-mp="1s2ia1gs3cvgp">
          {collection}
        </p>}
      <p className="mt-1 font-heading text-[12px] font-bold leading-snug text-brand md:text-[13px]" data-id="element-22" data-mp="1n9yuwfdr9s9s">{subtitle}</p>
      <p className="mt-0.5 flex flex-wrap items-center gap-2 font-heading text-[11px] font-extrabold uppercase md:text-[12px]" data-id="element-23" data-mp="1de5n19azemyc">
        {showReferencePrice && <s className="font-semibold text-ink/60" data-id="element-24" data-mp="19az719y2hheo">{formatPrice(price)}</s>}
        <span className="text-check" data-id="element-25" data-mp="14cnz54rc1gz3">Free with your purchase</span>
      </p>
      <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-26" data-mp="zeme4eacj7kz">
        {intro.map(p => <p key={p} data-id="element-27" data-mp="2yrql4sh6agx9">{p}</p>)}
      </div>
      {list && <ul className="mt-1.5 space-y-0.5 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-28" data-mp="2tsdvy12twxri">
          {list.map(item => <CheckItem key={item} data-id="element-29" data-mp="s2y8thfsreix">{item}</CheckItem>)}
        </ul>}
      {groups && <dl className="mt-2 space-y-1.5 text-[14px] leading-[1.4] md:text-[15px]" data-id="element-30" data-mp="wu6noszwbs3h">
          {groups.map(g => <div key={g.label} data-id="element-31" data-mp="i6d1uqk7vtcg">
              <dt className="font-heading text-[12px] font-extrabold uppercase text-navy md:text-[13px]" data-id="element-32" data-mp="i37ebfr8kziu">{g.label}</dt>
              <dd className="text-ink" data-id="element-33" data-mp="1atz6m256l40w">{g.text}</dd>
            </div>)}
        </dl>}
      {outro && <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-34" data-mp="1ft2ctpwwdgag">
          {outro.map(p => <p key={p} data-id="element-35" data-mp="10uqj9s4tmnni">{p}</p>)}
        </div>}
      <p className="mt-2 font-heading text-[12px] font-extrabold uppercase leading-tight text-goldDark md:text-[13px]" data-id="element-36" data-mp="15u3dwz1xoz0n">
        {finalLine}
      </p>
      {meta && <p className="mt-1 text-[12px] font-semibold text-ink/70 md:text-[13px]" data-id="element-37" data-mp="3lnvav1bq76eg">{meta}</p>}
    </article>;
}